import React, { createContext } from 'react';
import axios from '../../axios';
import { differenceInYears } from 'date-fns'


const ApiContext = createContext({
})


export const ApiProvider = ({ children }) => {
    
    
    const countAllUser = async () => {
        
        const response = await axios.get('clientes');
        
        return response.data.length;
    }
    
    const countOnline = async () => {
        
        const response = await axios.get('admin/auth/online');
        
        return response;
    }
    
    const totalResgates = async (data) => {
        const response = await axios.post('admin/auth/resgates-admin', {data})
        
        return response;
    }
    
    const accessUsers = async () => {
        
        const response = await axios.get('admin/auth/access');
        
        return response.data[0].maximo;
    }
    
    const barGraphStats = async (uf, status) => {
        
        const response1 = await axios.post('admin/auth/bar-graph-status',{
            uf,
            status
        });
        
        let response        = response1.data.dataRequest.clienteRegisterMonth.adms[1];
        let totalAcessos    = response1.data.dataRequest.accessStats;
        let admUsers        = response1.data.dataRequest.usersAdm;
        let cliUsers        = response1.data.dataRequest.usersCli;
        let totalUsers      = response1.data.dataRequest.totalUsers;
        let janeiro         = response1.data.dataRequest.accessStats.janeiro;
        let fevereiro       = response1.data.dataRequest.accessStats.fevereiro;
        let marco           = response1.data.dataRequest.accessStats.marco;
        let abril           = response1.data.dataRequest.accessStats.abril;
        let maio            = response1.data.dataRequest.accessStats.maio;
        let junho           = response1.data.dataRequest.accessStats.junho;
        let julho           = response1.data.dataRequest.accessStats.julho;
        let agosto          = response1.data.dataRequest.accessStats.agosto;
        let setembro        = response1.data.dataRequest.accessStats.setembro;
        let outubro         = response1.data.dataRequest.accessStats.outubro;
        let novembro        = response1.data.dataRequest.accessStats.novembro;
        let dezembro        = response1.data.dataRequest.accessStats.dezembro;
        
        let janeiroCadastrosCliente         = response1.data.dataRequest.clienteRegisterMonth.cli[1];
        let fevereiroCadastrosCliente       = response1.data.dataRequest.clienteRegisterMonth.cli[2];
        let marcoCadastrosCliente           = response1.data.dataRequest.clienteRegisterMonth.cli[3];
        let abrilCadastrosCliente           = response1.data.dataRequest.clienteRegisterMonth.cli[4];
        let maioCadastrosCliente            = response1.data.dataRequest.clienteRegisterMonth.cli[5];
        let junhoCadastrosCliente           = response1.data.dataRequest.clienteRegisterMonth.cli[6];
        let julhoCadastrosCliente           = response1.data.dataRequest.clienteRegisterMonth.cli[7];
        let agostoCadastrosCliente          = response1.data.dataRequest.clienteRegisterMonth.cli[8];
        let setembroCadastrosCliente        = response1.data.dataRequest.clienteRegisterMonth.cli[9];
        let outubroCadastrosCliente         = response1.data.dataRequest.clienteRegisterMonth.cli[10];
        let novembroCadastrosCliente        = response1.data.dataRequest.clienteRegisterMonth.cli[11];
        let dezembroCadastrosCliente        = response1.data.dataRequest.clienteRegisterMonth.cli[12];
        
        let janeiroCadastrosAdm         = response1.data.dataRequest.clienteRegisterMonth.adms[1];
        let fevereiroCadastrosAdm       = response1.data.dataRequest.clienteRegisterMonth.adms[2];
        let marcoCadastrosAdm           = response1.data.dataRequest.clienteRegisterMonth.adms[3];
        let abrilCadastrosAdm           = response1.data.dataRequest.clienteRegisterMonth.adms[4];
        let maioCadastrosAdm            = response1.data.dataRequest.clienteRegisterMonth.adms[5];
        let junhoCadastrosAdm           = response1.data.dataRequest.clienteRegisterMonth.adms[6];
        let julhoCadastrosAdm           = response1.data.dataRequest.clienteRegisterMonth.adms[7];
        let agostoCadastrosAdm          = response1.data.dataRequest.clienteRegisterMonth.adms[8];
        let setembroCadastrosAdm        = response1.data.dataRequest.clienteRegisterMonth.adms[9];
        let outubroCadastrosAdm         = response1.data.dataRequest.clienteRegisterMonth.adms[10];
        let novembroCadastrosAdm        = response1.data.dataRequest.clienteRegisterMonth.adms[11];
        let dezembroCadastrosAdm        = response1.data.dataRequest.clienteRegisterMonth.adms[12];
        
        let dados = {
            response,
            totalAcessos, 
            admUsers,
            cliUsers,
            totalUsers,
            janeiro,
            fevereiro,
            marco,
            abril,
            maio,
            junho,
            julho,
            agosto,
            setembro,
            outubro,
            novembro,
            dezembro,
            janeiroCadastrosCliente,
            fevereiroCadastrosCliente,
            marcoCadastrosCliente,
            abrilCadastrosCliente,
            maioCadastrosCliente,
            junhoCadastrosCliente,
            julhoCadastrosCliente,
            agostoCadastrosCliente,
            setembroCadastrosCliente,
            outubroCadastrosCliente,
            novembroCadastrosCliente,
            dezembroCadastrosCliente,
            janeiroCadastrosAdm,
            fevereiroCadastrosAdm,
            marcoCadastrosAdm,
            abrilCadastrosAdm,
            maioCadastrosAdm,
            junhoCadastrosAdm,
            julhoCadastrosAdm,
            agostoCadastrosAdm,
            setembroCadastrosAdm,
            outubroCadastrosAdm,
            novembroCadastrosAdm,
            dezembroCadastrosAdm
        }
        return dados;
    }
    
    
    const newClienteUsers = async(data) => {
        const response = await axios.post('admin/auth/new-users', {
            data
        });
        return response.data.users;
    }
    
    const totalPontosDashboard = async(data) => {
        
        const response = await axios.post('admin/auth/total-pontos', {
            data
        });
        
        let retorno = {pontos: 0, resgates: 0};
        
        if(response.data.length > 0){
            retorno.pontos = response.data[0].pontos;
            retorno.resgates = response.data[0].resgates;
        }
        
        return retorno;
    }
    
    const totalviewScoring = async(data) => {
        const response = await axios.post('admin/auth/total-view-scoring', {
            data
        });
        
        return response.data[0].count;
    }
    
    const totalAnuncios = async(usuario,data) => {
        
        const response = await axios.post('admin/auth/total-anuncios', {usuario,data});
        
        
        return response;
    }
    
    
    
    const statCard = async(data) => {
        const response = await axios.post('admin/auth/stat-card', {data});
        
        
        return response;
    }
    
    const graficoAnunciante = async(usuario, data, regiao, dataInfoGra, idade, genero) => {
        
        
        const response = await axios.post('admin/auth/grafico-anunciante', {usuario, data, regiao, dataInfoGra, idade });
        
        
        function filtroVisualizacao() {
            const regions = response.data.visualizacoes;
            
            let filtroRegiao = '';
            let filtroGenero = '';
            let filtroFaixaEtaria = '';
            
            let hoje = new Date();
            
            if (regiao !== 'TD') {
                filtroRegiao = regions.filter(cliente => cliente.clientes[0].endereco.uf ==  regiao);
            }else{
                filtroRegiao = regions;
            }
            if (genero!== 'TD') {
                filtroGenero = filtroRegiao.filter(cliente => cliente.clientes[0].genero == genero );
            }else{
                filtroGenero = filtroRegiao;
            }
            if (idade == 0) {
                filtroFaixaEtaria = filtroGenero;
            } else {
                let hoje = new Date(); 
                
                if (idade == 1) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 18 )
                }
                if (idade == 2) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) > 18).filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 30)
                }
                if (idade == 3) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) >= 30).filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 50)
                }
                if (idade == 4) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) > 50)
                }
                
            }
            
            
            let testando = filtroFaixaEtaria;
            // const regions = response.data.visualizacoes.filter(cliente => cliente.clientes[0].endereco.uf == regiao)
            let filtroFeito = testando;
            return filtroFeito ;
        };
        
        function filtroCliques() {
            const regions = response.data.cliques;
            
            let filtroRegiao = '';
            let filtroGenero = '';
            let filtroFaixaEtaria = '';
            
            let hoje = new Date();
            
            if (regiao !== 'TD') {
                filtroRegiao = regions.filter(cliente => cliente.clientes[0].endereco.uf ==  regiao);
            }else{
                filtroRegiao = regions;
            }
            if (genero!== 'TD') {
                filtroGenero = filtroRegiao.filter(cliente => cliente.clientes[0].genero == genero );
            }else{
                filtroGenero = filtroRegiao;
            }
            if (idade == 0) {
                filtroFaixaEtaria = filtroGenero;
            } else {
                let hoje = new Date(); 
                
                if (idade == 1) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 18 )
                }
                if (idade == 2) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) > 18).filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 30)
                }
                if (idade == 3) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) >= 30).filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) < 50)
                }
                if (idade == 4) {
                    filtroFaixaEtaria = filtroGenero.filter(cliente => differenceInYears( hoje,new Date(cliente.clientes[0].nascimento)) > 50)
                }
                
            }
            
            
            let testando = filtroFaixaEtaria;
            
            let filtroFeito = testando;
            return filtroFeito ;
        };
        let retornoVisualizacao = filtroVisualizacao();
        let retornoCliques = filtroCliques(); 
        
        const retornoAnunciante = {
            cliques: response.data.cliques,
            visualizacoes: response.data.visualizacoes,
            visualizacoesFiltradas: retornoVisualizacao.length, 
            cliquesFiltrados: retornoCliques.length,
            
        };
        
        
        return retornoAnunciante ;
    }
    
    const clientesTable = async(data) =>{
        const response = await axios.post('admin/auth/clientes-table', {data});
        
        
        return response;
    }
    
    const clientesExtratos = async(data) =>{
        const response = await axios.post('admin/auth/clientes-extratos');
        
        return response;
    }
    
    const clienteExtratoIndividual = async(user) =>{
        const response = await axios.post('admin/auth/cliente-extrato-individual', {user});
        
        
        return response;
    }
    
    const totalCupons = async(data) =>{
        const response = await axios.post('admin/auth/total-cupons', {data});
        
        return response.data.length;
    }
    
    
    //financeiro administrativo
    
    const financeiroAdm = async(data) =>{
        
        // console.log(data);
        const response = await axios.post('admin/auth/financeiro-adm', {data});
        
        return response;
    }
    
    //contratos
    const createContrato = async(data) =>{
        
        // console.log(data);
        const response = await axios.put('admin/auth/contrato', {data});
        
        
        // return response;
    }
    
    const financeiroAdmIndividual = async(data) =>{
        const response = await axios.post('admin/auth/financeiro-individual', {data});
        
        
        return response;
    }
    
    const updateContrato = async(data) => {
        
        
        const response = await axios.put('admin/auth/contrato-update', {data});
        
        // console.log('Contrato upload contrato com arquivo');
        // console.log(response );
        // console.log('fim contrato upload');
        
        
        return response;
    }
    
    
    //anunciantes
    
    const getAnunciantes = async(data) =>{
        const response = await axios.get('anunciantes');
        
        return response;
    }
    
    //contratos
    
    
    const getCuponsAnunciante = async(anunciante) =>{
        
        
        
        const response = await axios.post('admin/auth/cupons-anunciante', {anunciante});
        
        
        
        return response;
    }
    
    //fatura
    const createFatura = async(data) =>{
        
        
        const response = await axios.put('admin/auth/create-fatura', {data});
        
        
        
        // return response;
    }
    
    const getFaturasAdm = async(dataInicio,dataFim) =>{
        
        
        
        const response = await axios.post('admin/auth/faturas-anunciante', {dataInicio,dataFim});
        
        
        
        return response;
    }
    
    const getFaturaAdm = async(data,usuario) =>{
        
        // console.log(data);
        const response = await axios.post('admin/auth/fatura-anunciante', {data,usuario});
        
        
        
        return response;
    }
    
    const getFaturas = async(data,tipo) =>{
        
        
        
        const response = await axios.post('anunciantes/faturas-anunciante', {data,tipo});
        
        
        
        return response;
    }
    
    const getFatura = async(data,usuario) =>{
        
        // console.log(data);
        const response = await axios.post('anunciantes/fatura-anunciante', {data,usuario});
        
        
        
        return response;
    }
    
    //permissoes
    
    const getPermissao = async(anunciante) =>{
        
        // console.log(anunciante)
        
        const response = await axios.post('admin/auth/permissoes-anunciante', {anunciante});
        
        //   console.log('permissoes do anunciante');
        //   console.log(response);
        //   console.log('***********************');
        
        return response;
    }
    
    
    // Financeiro Anunciante
    
    const getContratosAnunciante = async(anunciante) =>{
        
        // console.log(anunciante)
        
        const response = await axios.post('anunciantes/contratos-anunciante', {anunciante});
        
        //   console.log('permissoes do anunciante');
        //   console.log(response);
        //   console.log('***********************');
        
        return response;
    }
    
    
    const getVisualizacoesAnuncios = async(anunciante) =>{
        
        // console.log(anunciante)
        
        const response = await axios.post('anunciantes/visualizacoes-anunciante', {anunciante});
        
        //   console.log('permissoes do anunciante');
        //   console.log(response);
        //   console.log('***********************');
        
        return response;
    }

    const invalidUsers = async(data) => { 
        const response = await axios.post('admin/auth/invalid-users', {data});
        
        //   console.log('permissoes do anunciante');
        //   console.log(response);
        //   console.log('***********************');
        
        return response;
    }
    
    
    return (
        <ApiContext.Provider
        value={{
            countAllUser,
            countOnline,
            totalResgates,
            accessUsers,
            barGraphStats,
            totalPontosDashboard,
            totalviewScoring,
            newClienteUsers,
            
            totalAnuncios,
            graficoAnunciante,
            
            clientesTable, 
            clientesExtratos,
            clienteExtratoIndividual,
            totalCupons, 
            
            financeiroAdm,
            createContrato,
            getAnunciantes,
            financeiroAdmIndividual,
            updateContrato,
            // uploadContratoPDF,
            getCuponsAnunciante,
            getPermissao,
            
            getContratosAnunciante,
            createFatura, 
            getFaturas,
            getFatura,
            getFaturasAdm, 
            
            getVisualizacoesAnuncios,
            invalidUsers,
        }}
        >
        {children}
        </ApiContext.Provider>
        )
    }
    
    export default ApiContext
    